import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import translate from "@insite/client-framework/Translate";
import { getAccessorials } from "@tKgpco/Services/AccessorialsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorial, AccessorialsFormValues, AccessorialState } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = { queryParams: Partial<AccessorialsFormValues>, onSuccess: () => void } & HasOnSuccess & HasOnError;

type HandlerType = CustomApiHandler<Parameters, AccessorialState>;

export const BeginExportAccessorial: HandlerType = props => {
    props.dispatch({ type: "Custom/Accessorials/ShowOverlay" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAccessorials(props.parameter.queryParams);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExportData: HandlerType = async props => {
    const { unparse } = await import(/* webpackChunkName: "papaparse" */ "papaparse");

    const data: any[] = [];
    const state = props.getState();
    const language = state.context.session.language;
    const accessorialData = (accessorial: Accessorial) => {
        return [
            accessorial.master,
            accessorial.name,
            accessorial.type,
            accessorial.tI_Code,
            accessorial.tI_Description,
            accessorial.enabled,
            accessorial.id,
            // getLocalizedDateTime({
            //     dateTime: new Date(accessorial.orderDate),
            //     language,
            // }),
        ];
    };

    if (props.apiResult) {
        props.apiResult?.accessorials.forEach((acc: Accessorial) => {
            data.push(accessorialData(acc));
        });
    }
    // Master	Name	Type	TI_Code	TI_Description	Enabled	Id
    const documentData = {
        fields: [
            translate("Master"),
            translate("Name"),
            translate("Type"),
            translate("TI_Code"),
            translate("TI_Description"),
            translate("Enabled"),
            translate("Id"),
        ],
        data,
    };

    const csv = unparse(documentData);
    const csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });

    const fileName = `accessorials_table.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(csvBlob);
    downloadLink.setAttribute("download", fileName);
    downloadLink.click();
};

export const CompleteExportAccessorial: HandlerType = props => {
    props.dispatch({ type: "Custom/Accessorials/HideOverlay" });
};

export const chain = [BeginExportAccessorial, RequestDataFromApi, ExportData, CompleteExportAccessorial];

const exportAccessorials = createHandlerChainRunner(chain, "ExportAccessorials");
export default exportAccessorials;
